import { VisibilityEdge } from './VisibilityEdge';
export class TollFreeVisibilityEdge extends VisibilityEdge {
    static constructorVV(source, target) {
        return new TollFreeVisibilityEdge(source, target, 0);
    }
    constructor(source, target, weight = 0) {
        super(source, target, weight);
    }
}
//# sourceMappingURL=TollFreeVisibilityEdge.js.map